//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  props: {
    currency: { type: String, required: true },
    cartItems: { type: Number, required: true }
  },
  data () {
    return {
      expanded: null,
      hovering: null
    }
  },
  computed: {
    ...mapGetters({
      isMobileMenuOpen: 'page/isMobileMenuOpen',
      flag: 'store/flag',
      currencySymbol: 'store/currencySymbol'
    }),
    itemCountClass () {
      if (this.cartItems > 10) return 'sgi-sg20-basket-10'
      return `sgi-sg20-basket-${this.cartItems}`
    }
  },
  watch: {
    '$route.path' () {
      this.expanded = null
    }
  },
  methods: {
    toggleMobileMenu () {
      this.$store.commit('page/TOGGLE_MOBILE_MENU')
      if (!this.isMobileMenuOpen) this.expanded = null
    },
    isExpanded (key) {
      return this.expanded === key
    },
    toggleExpanded (key) {
      if (this.isExpanded(key)) this.expanded = null
      else this.expanded = key
    },
    isHovering (key) {
      return this.hovering === key
    },
    handleMouseOver (key) {
      this.hovering = key
    },
    handleMouseLeave (key) {
      this.hovering = null
    }
  }
}
